import { observer } from 'mobx-react';
import React, { useContext, useEffect, useCallback, useState, FC } from 'react';
import { __RouterContext } from 'react-router';
import { modalContext } from '../../state/modalState';
import { profileContext } from '../../state/profileState';
import { searchContext } from '../../state/search/searchState';
import { logoutEvent } from '../../state/rxjs';
import { BlockMobile } from '../common/blocks/Blocks';
import {
  DropdownContentProps,
  DropdownTogglerProps,
  DropdownUniversal,
} from '../common/dropdown/DropdownUniversal';
import { IconSortDown, IconMenu } from '../common/icons';
import { Spinner } from '../common/spinner/Spinner';
import './Dropdown.css';
import { DDListContainer, DDListOption } from 'components/common/input/common';

export const Dropdown = observer(() => {
  const routerState = useContext(__RouterContext);
  const profileState = useContext(profileContext);
  const modalState = useContext(modalContext);
  const searchState = useContext(searchContext);
  const [active, setActive] = useState(false);
  const isSsoLogin = !!profileState.isSsoLogin;
  let elementIndex = 0;

  const doLogout = () => {
    logoutEvent.subscribe(() => {
      searchState.clearSearch();
      routerState.history.push('/login');
    });
    profileState.logout();
  };

  const openProfileModal = () => {
    modalState.toggleModal('profile', true, 'button:has(#user-menu-label)');
  };

  const openChangePasswordModal = () => {
    modalState.toggleModal('changePassword', true, 'button:has(#user-menu-label)');
  }

  if (!profileState.profileData || profileState.updatingProfile) {
    return <Spinner dots={true} style={{ top: '5px', right: '20px' }} />;
  }
  return (
    <>
      <DropdownUniversal
        className={'user-menu'}
        onShow={() => {
            setActive(true);

            requestAnimationFrame(() => {
                const profile = document.getElementById('profile');
                profile?.focus();
            });
        }}
        onClose={() => { setActive(false); }}
        toggler={Toggler}
        focusTogglerOnClose={false}
        content={({ close }: DropdownContentProps) => (
          <div className='user-menu__content'>
            <BlockMobile>
              <span
                id='profile'
                tabIndex={0}
                role="button"
                onClick={close}
                className='user-menu__label user-menu__label--mobile'
              >
                {!profileState.profileData!.firstName &&
                !profileState.profileData!.lastName ? (
                  'Profile'
                ) : (
                  <>
                    {profileState.profileData!.firstName}{' '}
                    {profileState.profileData!.lastName}
                  </>
                )}
              </span>
            </BlockMobile>
            <DDListContainer
              id='user-menu'
              active={active}
              kbdSelector={'div.select-option'}
              aria-labelledby='user-menu-label'
            >
              <DDListOption index={elementIndex++} onClick={openProfileModal} tabIndex={0} role="button">
                My details
              </DDListOption>

              {!isSsoLogin && (
                <DDListOption index={elementIndex++} onClick={openChangePasswordModal} tabIndex={0} role="button">
                  Change password
                </DDListOption>
              )}

              <DDListOption index={elementIndex++} onClick={doLogout} tabIndex={0} role="button">
                Logout
              </DDListOption>
            </DDListContainer>
          </div>
        )}
        togglerProps={{
          'role': 'button',
          'aria-labelledby': 'user-menu-label',
          'aria-haspopup': 'true',
          'aria-expanded': active,
          'aria-controls': active ? 'user-menu' : undefined
        }}
      />
    </>
  );
});

const Toggler: FC<DropdownTogglerProps> = ({ isOpened }) => {
  const profileState = useContext(profileContext);

  return (
    <div className='user-menu__toggler'>
    <span id='user-menu-label' className='user-menu__label'>
      {!profileState.profileData!.firstName &&
      !profileState.profileData!.lastName ? (
        'Profile'
      ) : (
        <>
          {profileState.profileData!.firstName}{' '}
          {profileState.profileData!.lastName}
        </>
      )}
    </span>
    <div
      className={
        'user-menu__toggler-icon ' + (isOpened ? 'flipped' : '')
      }
    >
      <IconSortDown />
      <IconMenu />
    </div>
  </div>
  );
};